import styled from 'styled-components'
import { warmPalette, neutralPalette } from '../../styles/abstracts/_variables.styles'
import * as breakpoints from '../../styles/abstracts/_breakpoints'

export const ImpactSection = styled.section`
  padding: clamp(4rem, 8vw, 8rem) clamp(1.5rem, 8vw, 10rem);
  background: ${warmPalette.primaryDark};
  color: ${neutralPalette.white};
`

export const ImpactIntro = styled.div`
  display: grid;
  max-width: 70rem;
  margin: 0 auto 3.5rem;

  @media ${breakpoints.largeDevices}, ${breakpoints.extraLargeDevices}, ${breakpoints.xxLargeDevices} {
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
    column-gap: 5rem;
  }
`

export const ImpactEyebrow = styled.p`
  margin: 0 0 0.85rem;
  color: ${warmPalette.tertiary};
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`

export const ImpactHeading = styled.h2`
  margin: 0;
  color: ${neutralPalette.white};
  font-size: clamp(2rem, 4vw, 3.8rem);
  font-weight: 400;
  line-height: 1.08;
`

export const ImpactCopy = styled.p`
  margin: 1.5rem 0 0;
  max-width: 54ch;
  color: rgba(255, 255, 255, 0.82);
  font-size: clamp(1rem, 1.4vw, 1.2rem);
  line-height: 1.7;

  @media ${breakpoints.largeDevices}, ${breakpoints.extraLargeDevices}, ${breakpoints.xxLargeDevices} {
    margin-top: 2rem;
  }
`

export const StatsGrid = styled.div`
  display: grid;
  gap: 1px;
  max-width: 70rem;
  margin: 0 auto;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.35rem;
  background: rgba(255, 255, 255, 0.2);

  @media ${breakpoints.mediumDevices}, ${breakpoints.mediumDevicesLandscape}, ${breakpoints.largeDevices}, ${breakpoints.extraLargeDevices}, ${breakpoints.xxLargeDevices} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`

export const Stat = styled.div`
  min-height: 11rem;
  padding: 2rem;
  background: ${warmPalette.primaryDark};
`

export const StatValue = styled.p`
  margin: 0 0 0.5rem;
  color: ${warmPalette.tertiary};
  font-size: clamp(2.8rem, 6vw, 5rem);
  font-weight: 400;
  line-height: 1;
`

export const StatLabel = styled.p`
  margin: 0;
  max-width: 18ch;
  color: ${neutralPalette.white};
  font-size: 0.95rem;
  line-height: 1.45;
`

export const SourceLink = styled.a`
  display: block;
  width: fit-content;
  margin: 1.5rem auto 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.78rem;
  text-underline-offset: 0.2em;
`
